import { render, staticRenderFns } from "./OpenResponseQuizQuestion.vue?vue&type=template&id=234fb2ae"
import script from "./OpenResponseQuizQuestion.vue?vue&type=script&lang=js"
export * from "./OpenResponseQuizQuestion.vue?vue&type=script&lang=js"
import style0 from "./OpenResponseQuizQuestion.vue?vue&type=style&index=0&id=234fb2ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports